function normalize(value) {
  return value === null || value === undefined ? '' : value;
}

export function compareTableValues(left, right, type = 'text') {
  const a = normalize(left);
  const b = normalize(right);

  if (type === 'number') {
    return Number(a || 0) - Number(b || 0);
  }

  if (type === 'date') {
    const leftTime = a ? new Date(a).getTime() : 0;
    const rightTime = b ? new Date(b).getTime() : 0;
    return leftTime - rightTime;
  }

  if (type === 'boolean') {
    return Number(Boolean(a)) - Number(Boolean(b));
  }

  return String(a).localeCompare(String(b), 'ru', {
    sensitivity: 'base',
    numeric: true,
  });
}

export function sortTableRows(rows, {
  sortBy,
  sortDir = 'asc',
  accessors = {},
  types = {},
} = {}) {
  const source = Array.isArray(rows) ? [...rows] : [];
  if (!sortBy) return source;

  const accessor = accessors[sortBy] || ((row) => row?.[sortBy]);
  const direction = sortDir === 'desc' ? -1 : 1;
  const type = types[sortBy] || 'text';

  return source.sort((left, right) => (
    compareTableValues(accessor(left), accessor(right), type) * direction
  ));
}
